const modalActionTypes = {
  MODAL_SET_COMPONENT: 'MODAL_SET_COMPONENT',
  MODAL_CLOSE: 'MODAL_CLOSE',
};

export default modalActionTypes;
